import { rolesTypes } from "../actions/roles";

const initialState = {
  isLoading: false,
  isDownloaded: "",
  currentModal: false,
  error: null,
  roles:[],
  filters: {
    isLoaded: false,
    name:"",
    sort: [
      {
        field: "createdon",
        order: "desc",
      },
    ],
    pagenumber: 0,
    limitnumber: 50,
  },
};

const rolesReducer = (state = initialState, action) => {
    switch (action.type) {
      case rolesTypes.FETCH_REQUEST:
      return {
        ...state,
        isLoading: true
      };
      case rolesTypes.FETCH_SUCCESS:
      return {
        ...state,
        isLoading: false,
        roles: action.payload,
        filters: {
          ...state.filters,
          isLoaded: true,
        },
      };
      case rolesTypes.FETCH_FAILURE:
      return {
        ...state,
        isLoading: false,
        roles: [],
        error: action.payload
      };
      case rolesTypes.DOWNLOAD_REQUEST:
        return {
          ...state,
          isDownloaded: "Downloading....",
          isLoading: true,
        };
      case rolesTypes.DOWNLOAD_SUCCESS:
        return {
          ...state,
          isLoading: false,
          isDownloaded: "Downloaded",
        };
      case rolesTypes.DOWNLOAD_FAILURE:
        return {
          ...state,
          isLoading: false,
          isDownloaded: "Something Went Wrong",
          error: action.payload,
        }; 
      case rolesTypes.SET_CURRENT_MODAL:
        return {
          ...state,
          currentModal: action.payload,
        }    
      default:
        return state;
    }
  };
  
  export default rolesReducer;